import { Link, useNavigate } from 'react-router-dom';
import { DropdownMenuItem } from '@c2fo/liquidity';
import { EyeIcon, PencilIcon } from '@c2fo/liquidity/icons';
import type { LocationDisplay } from '../../api/Locations';
import { StorageTypeChip } from '../StorageTypeChip';
import { UriLink } from '../UriLink';
import { DataGrid, DataGridCard } from '../DataGrid';
import { ActionsMenu } from '../ActionsMenu';
import { formatDateWithTimezone } from '../../../../utils/dateFormat';

interface LocationGridProps {
  locations: LocationDisplay[];
}

export const LocationGrid: React.FC<LocationGridProps> = ({ locations }) => {
  const navigate = useNavigate();

  return (
    <DataGrid>
      {locations.map((location) => (
        <DataGridCard key={location.uid}>
          <div className="flex items-center justify-between">
            <StorageTypeChip storageType={location.storageType} />
            <ActionsMenu>
              <DropdownMenuItem
                className="active:bg-lightBlue-100"
                onSelect={() => navigate(`/file-delivery/${location.name}`)}
              >
                <EyeIcon className="h-4 w-4 mr-2" />
                View Details
              </DropdownMenuItem>
              <DropdownMenuItem
                className="active:bg-lightBlue-100"
                onSelect={() => navigate(`/file-delivery/${location.name}/edit`)}
              >
                <PencilIcon className="h-4 w-4 mr-2" />
                Edit
              </DropdownMenuItem>
            </ActionsMenu>
          </div>

          <div>
            <span className="text-sm font-medium text-gray-900">{location.displayName}</span>
            {location.description && <p className="text-xs text-gray-500 mt-1 line-clamp-2">{location.description}</p>}
          </div>

          <div className="flex flex-col gap-1 text-xs text-gray-500">
            <div className="flex items-center gap-1">
              <span className="font-medium">URI:</span> <UriLink uri={location.uri} className="text-xs" />
            </div>
            <div>
              <span className="font-medium">Auth:</span>{' '}
              {location.credential ? (
                <Link
                  to={`/file-delivery/credentials/${location.credential.uid}`}
                  className="text-primary-600 hover:text-primary-700 hover:underline"
                >
                  {location.credential.displayName}
                </Link>
              ) : (
                <span className="text-gray-400">None</span>
              )}
            </div>
            <div>
              <span className="font-medium">Created:</span>{' '}
              {location.createTime ? formatDateWithTimezone(location.createTime) : '-'}
            </div>
          </div>
        </DataGridCard>
      ))}
    </DataGrid>
  );
};
